const groupBy = (array: Array<any>, property: string) => {
  var hash: any = {},
    props = property.split(".");
  for (var i = 0; i < array.length; i++) {
    var key = props.reduce(function (acc, prop) {
      return acc && acc[prop];
    }, array[i]);
    if (!hash[key]) hash[key] = [];
    hash[key].push(array[i]);
  }
  return hash;
};

export { groupBy as groupArrayBy };

export default groupBy;
